import StoryGame from './StoryGame.vue';
import StoryGameList from './StoryGameList.vue';
export default {
  StoryGame,
  StoryGameList,
};
